import { apiEndpoint } from '../utils/common';
import { post, queryStr } from '../utils/http';
import { API, CONTENT_TYPE } from '../constant';

/**
 * Card Token based on Saved Card Id.
 *
 * @param {Object} payload - Object to send in body
 * @param {Object} queryParams - Object to send in query  params
 * @returns {Promise<any>} - promise object contains response from server api
 */
export function getCacheCardToken(payload, queryParams) {
  const url = `${apiEndpoint(API.CACHE_CARD_TOKEN)}?${queryStr(queryParams)}`;
  return post.call(this, url, payload, {
    skipMiddleware: true,
    'Content-type': CONTENT_TYPE.FORM_URLENCODED
  });
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/src/api/sc.js